/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as s from "react";
import e from "prop-types";
import { validatePackage as i, classNames as n } from "@progress/kendo-react-common";
import { packageMetadata as c } from "./package-metadata.mjs";
const t = (o) => {
  const r = {
    direction: "start",
    ...o
  };
  i(c);
  const a = n(
    {
      "k-form-error": !0,
      "k-text-start": r.direction === "start",
      "k-text-end": r.direction === "end"
    },
    r.className
  );
  return /* @__PURE__ */ s.createElement(
    "div",
    {
      id: r.id,
      role: "alert",
      style: r.style,
      className: a
    },
    r.children
  );
};
t.propTypes = {
  id: e.string,
  direction: e.oneOf(["start", "end"]),
  children: e.oneOfType([
    e.element,
    e.node
  ]),
  style: e.object,
  className: e.string
};
t.displayName = "KendoReactError";
export {
  t as Error
};
